import { Input, InputProps, Skeleton, Spinner } from "@heroui/react";
import { MantineFormValues } from "./shared.types";
import React from "react";
import { cn } from "@/utils";
import { isMobileSafari, isSafari } from "react-device-detect";
import { isNativePlatform } from "@/utils/native";

export type LimeInputProps = Omit<MantineFormValues, "onChange"> &
  InputProps & {
    isLoading?: boolean;
    isSkeleton?: boolean;
    "data-identifier"?: string;
  };

export const LimeInput = React.forwardRef(
  ({ error, ...props }: LimeInputProps, ref: React.Ref<HTMLInputElement>) => {
    if (props.type === "email" && props.isDisabled && props.value) {
      return (
        <a href={`mailto:${props.value}`} className="w-full">
          <SharedInput ref={ref} error={error} {...props} />
        </a>
      );
    }

    return <SharedInput ref={ref} error={error} {...props} />;
  },
);
LimeInput.displayName = "LimeInput";

const SharedInput = React.forwardRef(
  (
    { error, isSkeleton, isLoading, ...props }: LimeInputProps,
    ref: React.Ref<HTMLInputElement>,
  ) => {
    return (
      <Skeleton
        isLoaded={!isSkeleton}
        className={cn(props.className, "w-full rounded-xl")}
      >
        <Input
          ref={ref}
          errorMessage={error}
          isInvalid={!!error}
          {...props}
          classNames={{
            ...props.classNames,
            input: cn(props.classNames?.input, {
              "text-[16px]": isMobileSafari || isSafari || isNativePlatform(),
            }),
          }}
          inputMode={props.type === "number" ? "numeric" : props.inputMode}
          endContent={isLoading ? <Spinner size="sm" /> : props.endContent}
        />
      </Skeleton>
    );
  },
);
SharedInput.displayName = "SharedInput";
